import React from 'react';
import { Box } from '@mui/material';

interface ActionCardProps {
    width?: number;
    height?: number;
    icon: JSX.Element;
    color: string;
    background?: string;
    fontSize?: number;
}

export function ActionCard({
    icon,
    color = 'text.secondary',
    background = 'background.light',
    width = 64,
    height = 64,
    fontSize,
}: ActionCardProps) {
    return (
        <Box
            sx={{
                width: width,
                height: height,
                borderRadius: '8px',
                background: background,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: color,
                fontSize: fontSize,
            }}>
            {icon}
        </Box>
    );
}
